import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { UserAuthorizationService } from '../services/user-authorization.service';
import { AuthGuard } from './auth-guard.service';

@Injectable({
    providedIn: 'root'
})
export class AdminAuthGuard extends AuthGuard implements CanActivate {
    constructor(private router: Router, authService: UserAuthorizationService) {
        super(authService);
    }

    public override async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        var isLoggedIn = await super.ensureUserIsLoggedIn(state);
        if (!isLoggedIn) return false;

        return this.ensureUserIsAdmin();
    }

    async ensureUserIsAdmin(): Promise<boolean> {
        var user = this.authService.getUser();
        if (user.isAdmin()) return true;

        // redirect to home
        this.router.navigateByUrl('/error');
        return false;
    }
}